import SettingsFieldHelpPopover from '../Common/SettingsFieldHelpPopover';

export default function NewsletterPlannedSendHelpPopover() {
  return (
    <SettingsFieldHelpPopover
      panelTitle="Planned send date & time"
      ariaLabel="Planned send date help"
      align="right"
      intro={
        <>
          This is when subscribers should receive the email. Stored in your browser timezone and
          saved as UTC. It does <strong className="font-semibold">not</strong> send by itself.
        </>
      }
      sections={[
        {
          heading: 'Draft + date',
          body: 'Calendar planning only. Nothing queues or sends until status is Scheduled or you queue recipients manually.',
        },
        {
          heading: 'Scheduled + date',
          body: 'You committed to this send. Recipients auto-queue about 24 hours before this time (every 30 minutes), or use Actions → Queue recipients sooner.',
        },
        {
          heading: 'After recipients are queued',
          body: 'Mail goes out at or shortly after this time (send cron every ~5 minutes). Send now in Actions uses the current time instead.',
        },
        {
          heading: 'Required for scheduling',
          body: 'Queue recipients and auto-queue both need a send date. Pick the date before setting status to Scheduled.',
        },
      ]}
    />
  );
}
